"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var LftIconButton_1 = __importDefault(require("../LftIconButton"));
var LftInputBase_1 = __importDefault(require("../LftInputBase"));
var LftHelper_1 = __importDefault(require("../LftHelper"));
var eye_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/eye"));
var eye_off_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/eye_off"));
var S = __importStar(require("./LftInputPassword.styles"));
var LftInputPassword = function (_a) {
    var autoComplete = _a.autoComplete, bgColor = _a.bgColor, dataElement = _a.dataElement, dataInfo = _a.dataInfo, dataTestId = _a.dataTestId, disabled = _a.disabled, helper = _a.helper, _b = _a.helperText, helperText = _b === void 0 ? 'HelperText' : _b, _c = _a.id, id = _c === void 0 ? 'InputPassword' : _c, _d = _a.label, label = _d === void 0 ? 'Label' : _d, _e = _a.maxLength, maxLength = _e === void 0 ? 100 : _e, _f = _a.name, name = _f === void 0 ? 'InputPassword' : _f, _g = _a.placeholder, placeholder = _g === void 0 ? 'InputText' : _g, _h = _a.required, required = _h === void 0 ? false : _h, _j = _a.status, status = _j === void 0 ? 'default' : _j, _k = _a.tabIndex, tabIndex = _k === void 0 ? 0 : _k, value = _a.value, lftBlur = _a.lftBlur, lftChange = _a.lftChange, lftFocus = _a.lftFocus, lftKeyUp = _a.lftKeyUp;
    var _l = (0, react_1.useState)(value), localValue = _l[0], setLocalValue = _l[1];
    var _m = (0, react_1.useState)(false), showPassword = _m[0], setShowPassword = _m[1];
    var onChange = function (e) {
        var newValue = e.currentTarget.value;
        setLocalValue(newValue);
        !!lftChange && lftChange(newValue);
    };
    var _handleShowPassword = function () {
        var status = !showPassword;
        setShowPassword(status);
    };
    (0, react_1.useEffect)(function () {
        setLocalValue(value);
    }, [value]);
    return ((0, jsx_runtime_1.jsxs)(S.Wrapper, __assign({ status: status, bgColor: bgColor, disabled: disabled, "aria-disabled": disabled, "data-lift": "lft-input" }, { children: [(0, jsx_runtime_1.jsxs)(S.InputWrapper, __assign({ bgColor: bgColor }, { children: [!!label && ((0, jsx_runtime_1.jsx)(S.Label, __assign({ "aria-disabled": disabled, bgColor: bgColor, "data-lift": "lft-input-label", disabled: disabled, htmlFor: id, title: label }, { children: label }))), (0, jsx_runtime_1.jsx)(LftInputBase_1.default, { ariaDescribed: helper ? (name + "_helper") : undefined, autoComplete: autoComplete, dataElement: dataElement, dataInfo: dataInfo, dataLift: "password", dataTestId: dataTestId, disabled: disabled, id: id, maxLength: maxLength, name: name, placeholder: placeholder, required: required, tabIndex: tabIndex, type: showPassword ? 'text' : 'password', value: localValue, lftBlur: lftBlur, lftChange: onChange, lftFocus: lftFocus, lftKeyUp: lftKeyUp }), (0, jsx_runtime_1.jsx)(LftIconButton_1.default, { disabled: disabled, size: 'lg', lftClick: _handleShowPassword, icon: showPassword ? eye_1.default : eye_off_1.default, ariaLabel: showPassword ? 'Ocultar senha' : 'Mostrar senha', alt: showPassword ? 'ocultar' : 'mostrar', bgColor: bgColor })] })), !disabled && helper && (0, jsx_runtime_1.jsx)(LftHelper_1.default, { content: helperText, name: name, status: status })] })));
};
exports.default = LftInputPassword;
